import { gsap } from "gsap";
export default () => {
    const accTitles = document.querySelectorAll('.acc-heading');

    accTitles.forEach(accTitle =>{
        accTitle.addEventListener('click', ()=>{
            accTitles.forEach(el =>{
                if (accTitle == el ) {return}
                let data = el.getAttribute('data-open');
                gsap.to(document.getElementById(data), {
                    height:0,
                    duration: 0.5,
                    onComplete: () =>{
                       el.classList.remove('active');
                    }
                }) 
            })
            
            
            
            let openedAcc = accTitle.getAttribute('data-open');
                
            if (accTitle.classList.contains('active')) {
                
                gsap.to(document.getElementById(openedAcc), {
                    height:0,
                    duration: 0.5,
                    onComplete: () =>{
                        accTitle.classList.remove('active');
                    }
                }) 
                
            } else {
                gsap.to(document.getElementById(openedAcc), {
                    height:'auto',
                    duration: 0.5,
                    onStart: () =>{
                        accTitle.classList.add('active');
                    }
                })      
            }
        })
    })
}